import React, { lazy } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import TemplatesList from '../../pages/notification-templates/TemplatesList';
import EditTemplate from '../../pages/notification-templates/EditTemplate';
function ResponseTemplatesRoutes() {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route exact path={`${path}/:to`} component={TemplatesList} />
            <Route path={`${path}/edit/:id`} component={EditTemplate} />
        </Switch>
    );
}

export default ResponseTemplatesRoutes;
